import { useUserStoryUploadFlow } from '@src/stores-v2';
import { observer } from 'mobx-react-lite';

import AddStoriesModal from './Dashboard/user-story/AddStoriesModal';
import SpeakerIdentificationPrefetcher from './SpeakerIdentificationPrefetcher';
import UploadCompletionToaster from './UploadCompletionToaster';
import UploadStopwatchOverlay from './UploadStopwatchOverlay';

const hasTtfeStopwatchOverride = (): boolean => {
  try {
    return window.localStorage.getItem('ttfe.stopwatch') === '1';
  } catch {
    return false;
  }
};

const UserStoryUploadFlow = observer(() => {
  const store = useUserStoryUploadFlow();
  const {
    inProgressModalIds,
    handleModalClose,
    handleNewStoryBlankCreated,
    handleNewStoryInitialized,
    handleNewStoryCreated,
    handleNewStoryProgress,
    onSaveCallbacks,
    triggerSave,
  } = store;

  return (
    <>
      {inProgressModalIds.map(modalId => (
        <AddStoriesModal
          key={modalId}
          modalId={modalId}
          closeModal={handleModalClose}
          onStoryBlankCreated={handleNewStoryBlankCreated}
          onStoryInitialized={handleNewStoryInitialized}
          onStoryCreated={handleNewStoryCreated}
          onStoryProgress={handleNewStoryProgress}
          onSave={
            onSaveCallbacks[modalId] ? () => triggerSave(modalId) : undefined
          }
        />
      ))}
      <UploadCompletionToaster />
      {/* TTFE stopwatch (time to "Ready to Edit" / "Fully Processed" per
          upload). Off by default; opt in per browser for measurement runs with
          localStorage.setItem('ttfe.stopwatch', '1') (PLAT-11222 / PLAT-11696). */}
      {hasTtfeStopwatchOverride() && <UploadStopwatchOverlay />}
      <SpeakerIdentificationPrefetcher />
    </>
  );
});

export default UserStoryUploadFlow;
